import { apiBlob } from './client';

/** `GET /v1/cli/package`: the Hangar CLI tarball the app commits at vendor/hangar-cli.tgz (SPEC decision 29, plan P31). */
export const downloadCliPackage = (): Promise<Blob> => apiBlob('/v1/cli/package');
